<script>
    const DEBUG = false;

    export default {
        name: "wizard-steps",
        props: {
            currentStep: {
                type: Number,
                default: 0,
                required: true
            },
            steps: {
                type: Array,
                default: [],
                required: true
            }
        },
        methods: {
            lineClassAfter(step) {
                const baseClass = 'horizontal-line';
                if (step.stepCount < this.currentStep) {
                    return `${baseClass} active-line`;
                }
                if (this.isLastStepAndActive(step)) {
                    return `${baseClass} active-line`;
                }
                return `${baseClass} inactive-line`;
            },
            isLastStepAndActive(step) {
                const lastStep = this.steps.length - 1;
                return step.stepCount === lastStep && this.currentStep === lastStep;
            },
            debugOnlyHandleStep(step) {
                if (DEBUG) {
                    console.log(`[DEBUG ONLY] Stepping to ${step.stepCount}.`);
                    this.$emit('click', step.stepCount);
                }
            },
            getStepLabelClass(step) {
                return `step-label ${step.stepCount <= this.currentStep ? 'active-step' : 'inactive-step'}`;
            },
            getStepDotClass(step) {
                return `step-dot ${step.stepCount <= this.currentStep ? 'active-step-dot' : 'inactive-step-dot'}`;
            },
            getStepLineClass(step) {
                return `horizontal-line ${step.stepCount <= this.currentStep ? 'active-line' : 'inactive-line'}`;
            },
        }
    }
</script>

<template>
    <div class="d-flex flex-row justify-space-around align-center">
        <div v-for="step in steps" class="d-flex flex-column align-center w-100">
            <div class="d-flex flex-row align-center justify-center w-100">
                <hr :class="getStepLineClass(step)"/>
                <div @click="debugOnlyHandleStep(step)" :class="getStepDotClass(step)" >
                    <i v-if="step.stepCount < currentStep" class="fa-duotone fa-check fa-fw fa-lg"/>
                    <i v-else-if="isLastStepAndActive(step)" class="fa-duotone fa-check fa-fw fa-lg"/>
                </div>
                <hr :class="lineClassAfter(step)"/>
            </div>
            <div :class="getStepLabelClass(step)">
                {{step.name}}
            </div>
        </div>
    </div>
</template>

<style scoped>
    .step-dot {
        transition: all ease-in-out 0.3s;
        height: 32px;
        width: 32px;
        background-color: lightgrey;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 4px 0 4px;
    }
    .active-step-dot {
        height: 36px;
        width: 36px;
        background-color: grey;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 4px 0 4px;
    }
    .active-step {
        font-weight: bold;
        color: rgb(0, 51, 113);
    }
    .inactive-step {
        color: rgba(0,0,0,.38);
    }
    .step-label {
        display: flex;
        flex-shrink: 1;
        margin: 0 8px 0 8px;
    }
    .horizontal-line {
        transition: all ease-in-out 0.3s;
        display: flex;
        flex-grow: 1;
    }
    .active-line {
        border: 1px solid grey;
    }
    .inactive-line {
        border: 1px solid lightgrey;
    }
</style>
